import { Component, OnInit } from "@angular/core";
import { Router, ActivatedRoute } from "@angular/router";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { DataServiceService } from "../data-service.service";
import { DateHelperServiceService } from "../helpers/date-helper-service.service";
import { User } from "../model/login";

@Component({
  selector: "app-view-admin",
  templateUrl: "./view-admin.component.html",
  styleUrls: ["./view-admin.component.scss"],
})
export class ViewAdminComponent implements OnInit {
  userData: User;
  isLoading: boolean = true;
  userId: string = "";
  constructor(
    private dateHelper: DateHelperServiceService,
    private dataService: DataServiceService,
    private router: Router,
    private modalService: NgbModal,
    private route: ActivatedRoute
  ) {
    this.userId = this.route.snapshot.params.userId
      ? this.route.snapshot.params.userId
      : "";
  }

  ngOnInit(): void {
    this.getUserData().then(() => {
      this.isLoading = false;
    });
  }

  invalidForm() {
    return false;
  }

  editView(userId) {
    this.router.navigate(["/edit-admin", userId]);
  }

  isAdverseMediaEnabled(user: User) {
    return user && user.isAdverseMediaEnabled === true;
  }

  onAdverseMediaChange(enabled: boolean) {
    const previous = this.isAdverseMediaEnabled(this.userData);
    this.userData.isAdverseMediaEnabled = enabled;
    this.dataService
      .updateAdverseMediaEnabled(this.userId, enabled)
      .catch(() => {
        this.userData.isAdverseMediaEnabled = previous;
        alert("Failed to update Adversary Media Search setting.");
      });
  }

  async getUserData() {
    this.userData = await this.dataService.getUserById(this.userId);
    this.userData = this.userData[0];
  }
}
